module.exports = __webpack_public_path__ + "img/service-retake.2e43ddc5.png";